<template>
  <section id="listRates">
    <div class="columns">
      <div class="column is-4">
        <CompanySelector v-model="company" />
      </div>
    </div>
    <fieldset class="fieldset">
      <legend>Tarifas de la empresa</legend>
      <div class="columns">
        <div class="column">
          <vs-button
            color="primary"
            class="pl-3 pr-3"
            type="filled"
            icon="add"
            @click="newTariff"
          >
            Crear nueva tarifa
          </vs-button>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-table :data="listRates">
            <b-table-column field="code" label="Código" v-slot="props">
              {{ props.row.code }}
            </b-table-column>
            <b-table-column field="titulo" label="Título" v-slot="props">
              {{ props.row.title }}
            </b-table-column>
            <!-- <b-table-column field="valor" label="Valor" v-slot="props">
              {{ formatPrice(props.row.tariffValue) }}
            </b-table-column> -->
            <b-table-column field="ajustment" label="Ajuste" v-slot="props">
              {{ formatPrice(props.row.adjustment) }}
            </b-table-column>
            <b-table-column field="options" label="Opciones" v-slot="props">
              <b-field>
                <b-button
                  type="is-info"
                  title="Seleccionar"
                  @click="edit(props.row)"
                  style="margin-right: 3px"
                  icon-right="pencil"
                />
                <b-button
                  type="is-danger"
                  title="Eliminar"
                  @click="remove(props.row)"
                  icon-right="delete"
                />
              </b-field>
            </b-table-column>
            <template #empty>
              <div class="has-text-centered">Sin registros</div>
            </template>
          </b-table>
        </div>
      </div>
    </fieldset>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import { ROUTES } from "../../../global/api_routes";
import { configToast, TOAST_TYPES } from "../../../global/toast";
import { confirmation, formatPrice } from "../../../global/utils";
import CompanySelector from "../../../components/Shared/CompanySelector";
export default {
  name: "ListRates",
  components: { CompanySelector },
  data: () => ({
    isLoading: false,
    company: null,
    companies: [],
    listRates: [],
  }),
  watch: {
    company: function () {
      this.getTariffs();
    },
  },
  mounted() {},
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#rates_container");
      return instance.open(message, type);
    },
    newTariff() {
      this.$router.push(`/view/rate`);
    },
    edit(row) {
      this.$router.push(`/view/rate?code=${row.code}`);
    },
    remove(row) {
      confirmation(this, "¿Deseas elminar el registro?").then((result) => {
        if (!result) {
          return;
        }
        this.deleteTariff(row);
      });
    },
    deleteTariff(tariff) {
      this.isLoading = true;
      this.$http
        .delete(ROUTES.DASHBOARD.RATES.DELETE_RATE, {
          data: {
            tariffCode: tariff.code,
          },
        })
        .then(({ data }) => {
          this.isLoading = false;
          if (data.code > 0) {
            this.toast(
              "Se ha eliminado la tarifa correctamente",
              TOAST_TYPES.SUCCESS
            );
            this.getTariffs();
            return;
          }
          this.toast(data.message, TOAST_TYPES.ERROR);
        });
    },
    formatPrice(price) {
      return formatPrice(price);
    },
    getTariffs() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.RATES.GET_RATES, {
          params: {
            companyId: this.company,
          },
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.listRates = data.info;
            return;
          }
          this.listRates = [];
          this.toast("No se han encontrado registros", TOAST_TYPES.ERROR);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
